module.exports = "<dac-navbar [doubleNav]=\"false\"></dac-navbar>\n<h2>404: Page not found</h2>"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/page-not-found/page-not-found.component.html
// module id = ./src/app/theme/page-not-found/page-not-found.component.html
// module chunks = main